// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"22c4c599","453":"a28b2b32","538":"2cb2ff95","784":"c5e0e17c","837":"b078c200"}[chunkId] + ".chunk.js";
};